(function () {
    'use strict';

    angular.module('app.promos', [
        'app.core',
        'app.widgets'
    ]);
})();
